import * as React from 'react';
import { LabelBadge } from '@/components/common/LabelBadge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import {
  SESSION_TYPE_CONFIG,
  WHOLE_CLASS_REPORT_HINT,
} from '@/components/sessions/session-configs';

/** Session-type chip; whole-class shows a one-report hint on hover. */
export const SessionTypeBadge: React.FC<{ type: string; size: 'sm' | 'md' }> = ({ type, size }) => {
  const typeConfig = SESSION_TYPE_CONFIG[type];
  const badge = (
    <LabelBadge
      label={typeConfig?.label ?? type}
      icon={typeConfig?.icon}
      variant={typeConfig?.badgeVariant ?? 'ghost'}
      color={typeConfig?.badgeColor ?? 'var(--color-2-nuance-1)'}
      size={size}
    />
  );
  if (type !== 'whole_class') return badge;
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span>{badge}</span>
        </TooltipTrigger>
        <TooltipContent>{WHOLE_CLASS_REPORT_HINT}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
